import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TlkBadgeComponent } from '@itero/ui-toolkit-angular/badge';
import { IntuitiveIndication } from '../../models';
import { IndicationTranslatePipe } from '@shared/pipes/indication-translate.pipe';
import { RxIntuitiveIndicationMapperService } from '@modules/rx-intuitive-teeth-orchestrator/services/rx-intuitive-indication-mapper.service';

@Component({
	selector: 'rx-intuitive-indication-badge',
	templateUrl: './rx-intuitive-indication-badge.component.html',
	styleUrls: ['./rx-intuitive-indication-badge.component.scss'],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CommonModule, TlkBadgeComponent, IndicationTranslatePipe],
	host: {
		'[attr.data-size]': 'size'
	}
})
export class RxIntuitiveIndicationBadgeComponent {
	/** Display label (e.g. translated unit type name). */
	@Input() label = '';

	/** When true, renders only the leading `__icon` (no `tlk-badge` shell or label). */
	@Input() iconOnly = false;

	/** Unit type ID (UnitTypes) for indication coloring. */
	@Input() indication: IntuitiveIndication = this.indicationMapper.getDefaultIndication();

	/** Badge shell size (`tlk-badge`) and round leading icon diameter (see SCSS `data-size`). */
	@Input() size: 's' | 'm' = 'm';

	/** CSS modifier class derived from unit type ID (e.g. 'Crown', 'Inlay', 'Onlay'). */
	get indicationClass(): string {
		return (IntuitiveIndication[this.indication] as string | undefined) ?? 'default';
	}

	constructor(private readonly indicationMapper: RxIntuitiveIndicationMapperService) {}
}
